
import Typography from '@/ui-kit/components/typography';
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import StylesMixin from '@/ui-kit/mixins/styles';
import { ModalSlotName } from '@/ui-kit/components/modal/enums';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';

const MODAL_LIST_ITEMS = [
  `Our licensed brokerage ensures comprehensive information is captured
  in order to populate industry-standard contracts.`,
  'Online negotiations are efficient, with any agreed commissions included.',
  'Bōde experts review initial deals and flag potential issues before they become binding.',
];

export default {
  name: 'AdminListingsImportImportImagesModal',
  components: {
    Typography,
    ModalWindow,
  },
  mixins: [ModalCommonProps, StylesMixin],
  data() {
    return {
      TypographyProperty,
      TypographyType,
      ModalSlotName,
      listItems: MODAL_LIST_ITEMS,
    };
  },
};
